import { render, staticRenderFns } from "./failedModal.vue?vue&type=template&id=a56df008&scoped=true&"
import script from "./failedModal.vue?vue&type=script&lang=js&"
export * from "./failedModal.vue?vue&type=script&lang=js&"
import style0 from "./failedModal.vue?vue&type=style&index=0&id=a56df008&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56df008",
  null
  
)

export default component.exports